import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-cree-bon-liv',
  templateUrl: './cree-bon-liv.component.html',
  styleUrls: ['./cree-bon-liv.component.scss']
})
export class CreeBonLivComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
